export class RouterPathInfo {
    history: string[];
    closeRoute: string;
}
